import { useMutation } from 'react-query';
import request from '../../../helpers/request';
import requestsByIdsQuery from '../../../queries/requestsByIdsQuery';

const { fetch: fetchRequestsByIds } = requestsByIdsQuery;

const changeStageLifeCycle = async (body) => {
  const res = await request.put(
    `/Request/stage`,
    body,
    'Не получилось изменить стадию помещения',
    'Error',
    null
  );

  return res;
};

const useChangeStageLifeCycle = (onSuccess) => {
  const mutation = useMutation(changeStageLifeCycle, {
    onSuccess: async (res, body) => {
      if (res !== 'Error' && typeof onSuccess === 'function') {
        const data = await fetchRequestsByIds(body.ids, {
          errMsg: 'Не удалось получить список обновленных заявок',
        });

        onSuccess({ updatedRequests: data, failedRequests: [] });
      }
    },
  });

  return {
    changeStageLifeCycle: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export default useChangeStageLifeCycle;
